import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  tr: {
    translation: {
      // Navigation
      nav: {
        home: 'Ana Sayfa',
        about: 'Hakkımızda',
        services: 'Hizmetlerimiz',
        blog: 'Blog',
        contact: 'İletişim',
      },
      // Stats
      stats: {
        brokerage: {
          title: 'Aracılık Hizmetleri',
          subtitle: 'Finansmana Köprü',
        },
        energy: {
          title: 'Enerji Odaklı',
          subtitle: 'İş Geliştirme',
        },
        analysis: {
          title: 'Finansal Analiz',
          subtitle: 'Doğru Karar',
        },
      },
      // Hero
      hero: {
        title: 'Finansal Geleceğinizi Birlikte Şekillendiriyoruz',
        subtitle: 'Başarı odaklı analizler ve etkin risk yönetimi ile Stratejik Finansal Çözümler sunuyor, sürdürülebilir değer yaratımına odaklanıyoruz. Yatırım süreçlerinin yapılandırılmasından risk analizlerine kadar, finansal süreçlerin her aşamasında stratejik destek sağlıyoruz.',
        cta: 'Bizimle İletişime Geçin',
        learnMore: 'Daha Fazla Bilgi',
      },
      // About
      about: {
        title: 'Hakkımızda',
        subtitle: 'Stratejik Finansal Çözümler',
        description: 'Finansal danışmanlık, proje finansmanı ve kurumsal finansman alanlarında, aracılık hizmetleri dahil olmak üzere kapsamlı ve stratejik çözümler sunuyoruz.\n\nBankacılık geçmişimizden gelen güçlü finansal yetkinliğimiz ve sektörel uzmanlığımız sayesinde, müşterilerimizin ihtiyaçlarına özel, sürdürülebilir ve katma değer yaratan finansal yapılandırmalar geliştiriyoruz.\n\nGeniş ve etkin finans sektörü networkümüzü kullanarak; doğru finansman kaynaklarına erişim, uygun maliyetli yapılandırma ve güçlü yatırımcı ilişkileri kurulması süreçlerinde aktif rol alıyoruz. Sektörel bilgi birikimimiz ve çok yönlü tecrübemiz ile şirketlerin büyüme, yeniden yapılandırma ve yatırım süreçlerinde güvenilir bir çözüm ortağı olarak konumlanıyoruz.',
        experience: 'Yıllık Deneyim',
        clients: 'Mutlu Müşteri',
        projects: 'Başarılı Proje',
        mission: {
          title: 'Misyonumuz',
          text: 'Müşterilerimizin finansal ihtiyaçlarını doğru analiz ederek, sürdürülebilir ve stratejik finansman çözümleri sunmak.',
        },
        vision: {
          title: 'Vizyonumuz',
          text: 'Finansal danışmanlık alanında güvenilir, uzman ve tercih edilen bir çözüm ortağı olmak.',
        },
      },
      // Values
      values: {
        title: 'Değerlerimiz',
        trust: {
          title: 'Güven',
          text: 'Şeffaf ve etik iş anlayışı',
        },
        expertise: {
          title: 'Uzmanlık',
          text: 'Bankacılık temelli güçlü finansal bilgi birikimi',
        },
        solution: {
          title: 'Çözüm Odaklılık',
          text: 'Uygulanabilir ve sonuç üreten yaklaşımlar',
        },
        sustainability: {
          title: 'Sürdürülebilirlik',
          text: 'Uzun vadeli değer yaratma',
        },
      },
      // Services
      services: {
        title: 'Hizmetlerimiz',
        subtitle: 'Kurumsal Finansman Çözümleri',
        financial: {
          title: 'Stratejik Finansal Danışmanlık',
          text: 'Bankacılık ve finans sektöründe uzun yıllara dayanan profesyonel deneyimimiz sayesinde kurumsal finansman danışmanlığı, finansal modelleme ve analiz hizmetleri sunuyoruz.',
        },
        project: {
          title: 'Kurumsal ve Proje Finansmanı Danışmanlığı',
          text: 'Planlanan yatırımlar özelinde, firmalarımızın bilanço yapısına uygun ve en avantajlı maliyet koşullarına sahip finansman kaynaklarını analiz ediyoruz. Sahip olduğumuz bilgi birikimi ve güçlü iş ağı sayesinde karşılaştırmalı değerlendirmeler sunuyoruz.',
        },
        sector: {
          title: 'Sektör Bazlı Projeksiyon ve Uluslararası Fonlara Erişim Danışmanlığı',
          text: 'Enerji ve denizcilik başta olmak üzere stratejik sektörlerde, gerçek verilere dayalı farklı senaryolarda projeksiyonlar hazırlayarak finansman süreçlerine katkı sağlıyoruz.',
        },
      },
      // Approach
      approach: {
        title: 'Çalışma Yaklaşımımız',
        step1: {
          title: 'İhtiyaç Analizi',
          text: 'İşletmenin mevcut finansal yapısı ve hedefleri detaylı biçimde incelenir.',
        },
        step2: {
          title: 'Strateji ve Modelleme',
          text: 'Veriye dayalı finansal senaryolar ve yol haritası oluşturulur.',
        },
        step3: {
          title: 'Kaynak ve Yapılandırma',
          text: 'En uygun finansman ve proje modeli belirlenir.',
        },
        step4: {
          title: 'Uygulama ve İzleme',
          text: 'Süreçler düzenli raporlanır, performans sürekli takip edilir.',
        },
      },
      // Why Us
      whyUs: {
        title: 'Neden BEU Danışmanlık?',
        reason1: 'Bankacılık ve finans sektöründe uzun yıllara dayanan kurumsal metodoloji',
        reason2: 'Sektöre özel, uygulanabilir finansal çözümler',
        reason3: 'Şeffaf, ölçülebilir ve sonuç odaklı hizmet modeli',
        reason4: 'Güçlü ulusal ve uluslararası finansman ağı',
        reason5: 'Uzun soluklu iş birliğini esas alan güven ilişkisi',
      },
      // Contact
      contact: {
        title: 'İletişim',
        subtitle: 'Sizinle Tanışmak İstiyoruz',
        description: 'Finansal süreçlerinizi güçlendirmek, yatırımlarınızı doğru kaynaklarla buluşturmak ve sürdürülebilir büyüme için güvenilir bir yol haritası oluşturmak üzere bizimle iletişime geçebilirsiniz.',
        form: {
          name: 'Adınız Soyadınız',
          email: 'E-posta Adresiniz',
          phone: 'Telefon Numaranız',
          company: 'Şirket Adı',
          message: 'Mesajınız',
          submit: 'Mesaj Gönder',
          success: 'Mesajınız başarıyla gönderildi!',
          error: 'Bir hata oluştu. Lütfen tekrar deneyin.',
        },
      },
      // Blog
      blog: {
        title: 'Blog',
        subtitle: 'Finansal İçgörüler ve Sektör Analizleri',
        readMore: 'Devamını Oku',
        backToBlog: 'Blog\'a Dön',
        noPost: 'Henüz blog yazısı bulunmamaktadır.',
      },
      // Footer
      footer: {
        tagline: 'İşletmelerin finansal karar süreçlerini güçlendiren, yatırımlarını doğru kaynaklarla buluşturan kurumsal çözüm ortağınız.',
        quickLinks: 'Hızlı Bağlantılar',
        services: 'Hizmetlerimiz',
        contact: 'İletişim',
        rights: 'Tüm hakları saklıdır.',
        letsTalk: 'Konuşalım',
      },
      // Admin
      admin: {
        login: 'Giriş Yap',
        logout: 'Çıkış Yap',
        dashboard: 'Panel',
        blogManagement: 'Blog Yönetimi',
        contacts: 'İletişim Formları',
        newPost: 'Yeni Yazı',
        editPost: 'Yazıyı Düzenle',
        deletePost: 'Yazıyı Sil',
        save: 'Kaydet',
        cancel: 'İptal',
        email: 'E-posta',
        password: 'Şifre',
        loginError: 'Giriş bilgileri hatalı',
        markAsRead: 'Okundu İşaretle',
        delete: 'Sil',
        published: 'Yayında',
        draft: 'Taslak',
      },
    },
  },
  en: {
    translation: {
      // Navigation
      nav: {
        home: 'Home',
        about: 'About',
        services: 'Services',
        blog: 'Blog',
        contact: 'Contact',
      },
      // Stats
      stats: {
        brokerage: {
          title: 'Brokerage Services',
          subtitle: 'Bridge to Financing',
        },
        energy: {
          title: 'Energy Focused',
          subtitle: 'Business Development',
        },
        analysis: {
          title: 'Financial Analysis',
          subtitle: 'Right Decision',
        },
      },
      // Hero
      hero: {
        title: 'Shaping Your Financial Future Together',
        subtitle: 'We provide Strategic Financial Solutions with success-oriented analyses and effective risk management, focusing on sustainable value creation. From investment structuring to risk analysis, we provide strategic support at every stage of financial processes.',
        cta: 'Get in Touch',
        learnMore: 'Learn More',
      },
      // About
      about: {
        title: 'About Us',
        subtitle: 'Strategic Financial Solutions',
        description: 'We provide comprehensive and strategic solutions in financial consulting, project financing, and corporate finance, including brokerage services.\n\nWith our strong financial competence from our banking background and sectoral expertise, we develop sustainable and value-creating financial structures specific to our clients\' needs.\n\nUsing our broad and effective financial sector network, we play an active role in accessing the right financing sources, cost-effective structuring, and establishing strong investor relations. With our sectoral knowledge and versatile experience, we position ourselves as a reliable solution partner in companies\' growth, restructuring, and investment processes.',
        experience: 'Years Experience',
        clients: 'Happy Clients',
        projects: 'Successful Projects',
        mission: {
          title: 'Our Mission',
          text: 'To provide sustainable and strategic financing solutions by accurately analyzing our clients\' financial needs.',
        },
        vision: {
          title: 'Our Vision',
          text: 'To be a reliable, expert, and preferred solution partner in financial consulting.',
        },
      },
      // Values
      values: {
        title: 'Our Values',
        trust: {
          title: 'Trust',
          text: 'Transparent and ethical business approach',
        },
        expertise: {
          title: 'Expertise',
          text: 'Strong financial knowledge based on banking background',
        },
        solution: {
          title: 'Solution-Oriented',
          text: 'Applicable and result-producing approaches',
        },
        sustainability: {
          title: 'Sustainability',
          text: 'Long-term value creation',
        },
      },
      // Services
      services: {
        title: 'Our Services',
        subtitle: 'Corporate Finance Solutions',
        financial: {
          title: 'Strategic Financial Consulting',
          text: 'We provide corporate finance consulting, financial modeling and analysis services with our professional experience spanning many years in banking and finance sector.',
        },
        project: {
          title: 'Corporate and Project Finance Consulting',
          text: 'For planned investments, we analyze financing sources that are suitable for our companies\' balance sheet structure and have the most advantageous cost conditions. With our knowledge and strong business network, we provide comparative evaluations.',
        },
        sector: {
          title: 'Sector-Based Projection and Access to International Funds Consulting',
          text: 'We contribute to financing processes by preparing projections in different scenarios based on real data in strategic sectors, especially energy and maritime.',
        },
      },
      // Approach
      approach: {
        title: 'Our Working Approach',
        step1: {
          title: 'Needs Analysis',
          text: 'The current financial structure and objectives of the business are examined in detail.',
        },
        step2: {
          title: 'Strategy and Modeling',
          text: 'Data-driven financial scenarios and roadmaps are created.',
        },
        step3: {
          title: 'Resource and Structuring',
          text: 'The most suitable financing and project model is determined.',
        },
        step4: {
          title: 'Implementation and Monitoring',
          text: 'Processes are regularly reported, and performance is continuously monitored.',
        },
      },
      // Why Us
      whyUs: {
        title: 'Why BEU Consulting?',
        reason1: 'Corporate methodology based on extensive banking and finance experience',
        reason2: 'Sector-specific, applicable financial solutions',
        reason3: 'Transparent, measurable and result-oriented service model',
        reason4: 'Strong national and international financing network',
        reason5: 'Trust relationship based on long-term cooperation',
      },
      // Contact
      contact: {
        title: 'Contact',
        subtitle: 'We Want to Meet You',
        description: 'Contact us to strengthen your financial processes, connect your investments with the right resources, and create a reliable roadmap for sustainable growth.',
        form: {
          name: 'Your Name',
          email: 'Your Email',
          phone: 'Your Phone',
          company: 'Company Name',
          message: 'Your Message',
          submit: 'Send Message',
          success: 'Your message has been sent successfully!',
          error: 'An error occurred. Please try again.',
        },
      },
      // Blog
      blog: {
        title: 'Blog',
        subtitle: 'Financial Insights and Sector Analysis',
        readMore: 'Read More',
        backToBlog: 'Back to Blog',
        noPost: 'No blog posts yet.',
      },
      // Footer
      footer: {
        tagline: 'Your corporate solution partner that strengthens businesses\' financial decision-making processes and connects investments with the right resources.',
        quickLinks: 'Quick Links',
        services: 'Our Services',
        contact: 'Contact',
        rights: 'All rights reserved.',
        letsTalk: 'Let\'s Talk',
      },
      // Admin
      admin: {
        login: 'Login',
        logout: 'Logout',
        dashboard: 'Dashboard',
        blogManagement: 'Blog Management',
        contacts: 'Contact Forms',
        newPost: 'New Post',
        editPost: 'Edit Post',
        deletePost: 'Delete Post',
        save: 'Save',
        cancel: 'Cancel',
        email: 'Email',
        password: 'Password',
        loginError: 'Invalid credentials',
        markAsRead: 'Mark as Read',
        delete: 'Delete',
        published: 'Published',
        draft: 'Draft',
      },
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'tr',
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
